@if(quickFilterEventTypeArray.length > 0){
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
    @for (filterSymbolEventType of quickFilterEventTypeArray; track filterSymbolEventType + '-'+ $index; let i = $index){
    <ul class="nopadding">
      @if(filterSymbolEventType!=''){
      <label for="filterSymbolEventType">
        @if(filterSymbolEventType == activeSymbolEventType){
        <p-button [id]="filterSymbolEventType" type="button" class="button btn-xs active-symbol active-button">
          {{filterSymbolEventType}}
        </p-button>}
        @if(filterSymbolEventType != activeSymbolEventType){
        <p-button [id]="filterSymbolEventType" (click)="getName('QUICKFILTEREVENTTYPE',filterSymbolEventType,i)" type="button" class="button btn-xs non-active-symbol">
          {{filterSymbolEventType}}
        </p-button>}
      </label>}
    </ul>}
    <!-- Application Filters -->
    @for (ApplicationFilter of ApplicationFilterArray; track ApplicationFilter + '-'+ $index; let i = $index){
    <ul class="nopadding">
      @if(ApplicationFilter!=''){
      <label for="ApplicationFilter">
        <button [id]="ApplicationFilter?.id" type="button" pButton [ngClass]="(selectedApplicationFilter?.filter_query_name==ApplicationFilter?.filter_query_name) ? 'button btn-xs active-symbol-save-filter savedFilterButtons' : 'button btn-xs non-active-symbol savedFilterButtons'">
          <a (click)="getSelectedApplicationFilter(ApplicationFilter)">
            <i>{{ApplicationFilter.filter_query_name}}</i>
          </a>
          <a class = "symbol-close-icon" (click)="removeApplicationFilterQuery(ApplicationFilter)">
            <i class="fa fa-close" style="margin-left: -4px;"></i>
          </a>
        </button>       
      </label>}
    </ul>}
    <!-- End of Application Filters -->
  </div>
</div>
}


<!-- Group Name Quick Filter Code -->

@if(GroupNameArray && GroupNameArray.length > 0 && GroupNameArray[0] !== ''){
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
     <ul  class="nopadding">
        <label for="grouplabel"> Group &nbsp;:&nbsp;&nbsp;</label>
     </ul>
    @for (filterlabel of GroupNameArray; track filterlabel + '-'+ $index; let i = $index){
    <ul  class="nopadding">
      @if(filterlabel!=''){
      <label for="filterlabel">
        @if(filterlabel == activeGroupName){
        <p-button [id]="filterlabel" type="button" class="button btn-xs active-symbol">
          {{filterlabel}}
        </p-button>}
        @if(filterlabel != activeGroupName){
        <p-button [id]="filterlabel" (onClick)="getName('GroupName',filterlabel,i)" type="button" class="button btn-xs non-active-symbol">
          {{filterlabel}}
        </p-button>}
      </label>}
    </ul>}
  </div>
</div>
}

<!-- Sample Name Quick Filter Code -->

@if(SampleNameArray && SampleNameArray.length > 0 && SampleNameArray[0] !== ''){
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
     <ul  class="nopadding">
        <label for="samplelabel"> Custom Sample :&nbsp;&nbsp;</label>
     </ul>
    @for (customSample of SampleNameArray; track customSample + '-'+ $index; let i = $index){
    <ul  class="nopadding">
      @if(customSample!=''){
      <label for="customSample">
        <button [id]="customSample?.id" type="button" pButton  type="button" [ngClass]="(activeSampleName==customSample?.filter_query_name) ? 'button btn-xs active-symbol-save-filter savedFilterButtons' : 'button btn-xs non-active-symbol savedFilterButtons'">
          <a (click)="setCustomSampleFilter(customSample)">
            <em>{{customSample.filter_query_name}}</em>
          </a>
          <a class = "symbol-close-icon" (click)="removeCustomSampleFilterQuery(customSample)">
            <em class="fa fa-close" style="margin-left: -4px;"></em>
          </a>
        </button>
      </label>}
    </ul>}
  </div>
</div>
}


<!-- Symbol Quick Filter Code -->

@if(Symbol.length > 0 && Symbol[0] !== ''){
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
    @for (filterlabel of Symbol; track filterlabel + '-'+ $index; let i = $index){
    <ul  class="nopadding">
      @if(filterlabel!=''){
      <label for="filterlabel">
        @if(filterlabel == activeSymbol){
        <p-button [id]="filterlabel" type="button" class="button btn-xs active-symbol">
          {{filterlabel}}
            <sub>{{rowCount != null && rowCount != undefined && rowCount.toString() !== '0' ? rowCount : ''}}</sub>
        </p-button>}
        @if(filterlabel != activeSymbol){
        <p-button [id]="filterlabel" (click)="getName('Symbol',filterlabel,i)" type="button" class="button btn-xs non-active-symbol">
          {{filterlabel}}
        </p-button>}
      </label>}
    </ul>}
  </div>
</div>
}

<!-- Exception Code with records Count Quick Filter Code -->

@if(!isDisplayCodeBlock && NewCodeArray.length > 0){
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
        @for (filtercode of NewCodeArray; track filtercode + '-'+ $index; let i = $index){
    <ul class="nopadding">
      @if(!isDisplayCodeBlock && filtercode!=''){
      <label for="filtercode">
        @if(filtercode.code == activeCode){
        <p-button [id]="filtercode.code" [matTooltip]="filtercode.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" label=" " type="button" class="button btn-xs active-symbol">
          {{filtercode.code}}
        </p-button>}
        @if(filtercode.code != activeCode){
        <p-button [id]="filtercode.code"  (click)="getName('Code',filtercode.code,i)" [matTooltip]="filtercode.description" [matTooltipShowDelay]="1000" matTooltipPosition="after" label=" " type="button" class="button btn-xs non-active-symbol">
          {{filtercode.code}}
        </p-button>}
      </label>}
    </ul>}
  </div>
</div>}

<!-- Exception Code without records Count Quick Filter Code -->

<!-- Display Code Block -->
@if(isDisplayCodeBlock && CodeBlockArrayList.length > 0){
<div class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
    @for (filtercode of CodeBlockArrayList; track filtercode + '-'+ $index; let i = $index){
    <ul class="nopadding">
      @if(isDisplayCodeBlock && filtercode!=''){
      <label for="failurecode">
        <li>
          @if(filtercode.failurecode === activeCode){
          <a class="excpCodeBlockLink" [id]="filtercode.failurecode" [matTooltip]="filtercode.error_code_description" [matTooltipShowDelay]="1000" matTooltipPosition="after">
            <div [ngClass]="{'optedExcpCode': (filtercode.failurecode == activeCode), 'excpCodeBlock': !filtercode.isNamedErrorCode, 'namedExcpCodeBlock': filtercode.isNamedErrorCode}">
              <div class="text-center">
                <div [ngClass]="{'excpCode': !filtercode.isNamedErrorCode, 'namedExcpCode': filtercode.isNamedErrorCode}">
                  <strong>{{filtercode.failurecode}}</strong>
                </div>
                <div class="excpCount">
                  <Strong>{{filtercode.error_code_count | number}}</Strong>
                </div>
              </div>
            </div>
          </a>
          }
          @if(filtercode.failurecode !== activeCode){
          <a (click)="getName('Code',filtercode.failurecode,i)" class="excpCodeBlockLink" [id]="filtercode.failurecode" [matTooltip]="filtercode.error_code_description" [matTooltipShowDelay]="1000" matTooltipPosition="after">
            <div [ngClass]="{'optedExcpCode': (filtercode.failurecode == activeCode), 'excpCodeBlock': !filtercode.isNamedErrorCode, 'namedExcpCodeBlock': filtercode.isNamedErrorCode}">
              <div class="text-center">
                <div [ngClass]="{'excpCode': !filtercode.isNamedErrorCode, 'namedExcpCode': filtercode.isNamedErrorCode}">
                  <strong>{{filtercode.failurecode}}</strong>
                </div>
                <div class="excpCount">
                  <Strong>{{filtercode.error_code_count | number}}</Strong>
                </div>
              </div>
            </div>
          </a>
        }
        </li>
      </label>
    }
    </ul>}
  </div>
</div>
}
<!-- End of Displaying Code Block -->

<!-- <div *ngIf="DateList.length > 0 " class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
    <ul class="nopadding" *ngFor="let date of DateList;let i=index;">
      <label *ngIf="date!=''">
        <p-button *ngIf="date == activeDate"  [matTooltip]="date" matTooltipPosition="after" label=" " type="button" class="button btn-xs active-symbol">
          {{date}}
        </p-button>
        <p-button  (click)="getName('DATE',date,i)" *ngIf="date != activeDate"  [matTooltip]="date" matTooltipPosition="after" label=" " type="button" class="button btn-xs non-active-symbol">
          {{date}}
        </p-button>
      </label>
    </ul>
  </div>
</div> -->
<!-- <div *ngIf="DateList.length > 0 " class="col-lg-12 nopadding">
  <div class="ui-widget-header-1 nopadding">
    <ul class="nopadding" *ngFor="let filtercode of DateList;let i=index;">
      <label>
        <p-button   [matTooltip]="filtercode" matTooltipPosition="after" label=" " type="button" (onClick)="isDateFilterApplied = false" [ngClass]="isDateFilterApplied ? 'button btn-xs active-symbol-dark-blue mg-t-5':'button btn-xs non-active-symbol mg-t-5'">
          {{filtercode}}
        </p-button>
      </label>
    </ul>
  </div>
</div> -->

<!-- 
<div class="col-lg-12 nopadding">
  <mat-chip-list aria-label="Code">
    <span  >
    <mat-chip *ngFor="let filtercode of Symbol" [selectable]="filtercode"
             [removable]="removable" (click)="getName('Code',filtercode,i)"
             selected [color]="green">
      {{filtercode}}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      <sub>{{rowCountCode}}</sub>
    </mat-chip>
  </span>
  </mat-chip-list>
</div>


<div class="col-lg-12 nopadding">
      <mat-chip-list aria-label="Code">
        <span  >
        <mat-chip *ngFor="let filtercode of Code" [selectable]="filtercode"
                 [removable]="removable" (click)="getName('Code',filtercode,i)"
                 selected [color]="green">
          {{filtercode}}
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          <sub>{{rowCountCode}}</sub>
        </mat-chip>
      </span>
      </mat-chip-list>
</div> -->